module.exports = __webpack_public_path__ + "img/flag-viewpoint-3.f07c5a54.jpg";